import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams, HttpErrorResponse } from "@angular/common/http";
import { Observable, Subject, of } from "rxjs";
import { Sector, ClassMapper } from '@mapfre-tech/amap3';
import { map } from "rxjs/operators";
import * as _ from 'lodash';
import moment from 'moment';

@Injectable({
   providedIn: "root"
})
export class SectorService {
   constructor(private http: HttpClient) { }

   className = 'SectorService'

   memoryCache = {
      "sector": {
         "data": null,
         "lastReqDate": null
      }
   }

   getSectors(cache = true, cacheKey = "allSectors"): Observable<Sector[]> {
      if (this.canUseCache(cacheKey) && cache) {
         return (_.get(this.memoryCache, `${cacheKey}.data`) ? of(_.get(this.memoryCache, `${cacheKey}.data`)) : _.get(this.memoryCache, `${cacheKey}.observer`)) as unknown as Observable<Sector[]>
      } /*else {
         let observable = this.http.get<Sector[]>(environment.base_URL + "/sectors").pipe(map((res) => {
            this.updateCacheData(res, cacheKey) // aquí da error. Hay que eliminar todas las llamadas de sectores y hacer que estas dejen de tener sentido
            return res;
         }))
         this.updateCacheReq(cacheKey);
         return observable;
      }*/
      return of([]) as Observable<Sector[]>;
   }

   newSector(newSector) {
      return this.http.post(environment.base_URL + "/sectors", newSector)
   }

   updateSector(editedSector, id) {
      return this.http.put(environment.base_URL + `/sectors/${id}`, editedSector)
   }

   deleteSector(id) {
      return this.http.delete(environment.base_URL + `/sectors/${id}`)
   }

   canUseCache(key) {
      const oldDate = _.get(this.memoryCache, `${key}.lastReqDate`);
      let canUse = false;
      if (moment().diff(oldDate, 'minutes') <= 30) {
         canUse = true;
      }
      return canUse;
   }

   updateCacheData(data, key) {
      _.set(this.memoryCache, `${key}.data`, data);

      _.get(this.memoryCache, `${key}._subject`).next(data);
   }

   updateCacheReq(key) {
      const _subject = new Subject<any>();
      const observer = _subject.asObservable();
      _.set(this.memoryCache, key, { observer, _subject, lastReqDate: moment() });
   }

   getSectorRelations(sector) {
      const params: any = {};
      params.sectorId = sector.idSectorPk;
      return this.http.get<Sector[]>(environment.base_URL + "/sectors", { params });
   }

   getSectorByUnitBusinessAndCountry(unitBusinessId, countryId) {
      const params: any = {};
      params.unitBusinessId = unitBusinessId;
      params.countryId = countryId;
      return this.http.get<Sector[]>(environment.base_URL + "/sectors", { params });
   }
}
